<template>
  <div class="h-100">
    <div class="leaderboard-page">
      <h4> {{ $t("Home.Leaderboard") }}</h4>
      <b-row style="margin-top: 20px;width: 100%">
        <b-col
          lg="4"
          sm="6"
        >
          <div class="stat">
            <div class="labelLead">
              {{ $t('Home.GlobalNetspace') }}
            </div>
            <div class="valueLead">
              {{ $utils.getNetSpaceStr(ranking.netSpace) }}
            </div>
          </div>
        </b-col>
        <b-col
          lg="4"
          sm="6"
        >
          <div class="stat">
            <div class="labelLead">
              {{ $t('Home.PoolNetspace') }}
            </div>
            <div class="valueLead">
              {{ $utils.getNetSpaceStr(ranking.poolNetSpace) }}
            </div>
          </div>
        </b-col>
        <b-col
          lg="4"
          sm="6"
        >
          <div class="stat">
            <div class="labelLead">
              {{ $t('Home.GlobalPoints') }}
            </div>
            <div class="valueLead">
              {{ ranking.pointsAll }}
            </div>
          </div>
        </b-col>
      </b-row>
      <div style="display: flex;width: 100%;margin-top: 20px">
        <div class="table-column">
          <div class="table-title">
            {{ $t('Home.Rank') }}
          </div>
          <div
            v-for="( item ,index ) in farmsList"
            :key="index"
            class="table-text"
          >
            #{{ index + 1 }}
          </div>
        </div>
        <div class="table-column flexible">
          <div class="table-title">
            {{ $t('Home.Farmer') }}
          </div>
          <div
            v-for="( item ,index ) in farmsList"
            :key="index"
            class="table-text"
            style="color: #03b000;cursor: pointer;"
            @click="getDetail(item.launcherId,index + 1 )"
          >
            {{ item.launcherId }}
          </div>
        </div>
        <div class="table-column">
          <div class="table-title">
            {{ $t('Home.PlotSize') }}
          </div>
          <div
            v-for="( item ,index ) in farmsList"
            :key="index"
            class="table-text"
          >
            {{ $utils.getNetSpaceStr(item.plotSize) }}
          </div>
        </div>
        <div
          v-if="width>1024"
          class="table-column"
        >
          <div class="table-title">
            {{ $t('Home.Difficulty') }}
          </div>
          <div
            v-for="( item ,index ) in farmsList"
            :key="index"
            class="table-text"
          >
            {{ item.difficulty }}
          </div>
        </div>
        <div
          v-if="width>1024"
          class="table-column"
        >
          <div class="table-title">
            {{ $t('Home.Points') }}
          </div>
          <div
            v-for="( item ,index ) in farmsList"
            :key="index"
            class="table-text"
          >
            {{ item.points }}
          </div>
        </div>
        <div class="table-column">
          <div class="table-title">
            {{ $t('Home.Joined') }}
          </div>
          <div
            v-for="( item ,index ) in farmsList"
            :key="index"
            class="table-text"
          >
            {{ $utils.getTimeStr(item.createAt) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVerticalLayout from '@/@core/layouts/layout-vertical/useVerticalLayout'
import useAppConfig from '@core/app-config/useAppConfig'
import mixinVerticalLayout from '@/@core/layouts/layout-vertical/mixinVerticalLayout'
import {onUnmounted} from "@vue/composition-api";
import {BCol, BRow} from 'bootstrap-vue'
import {isUserLoggedIn} from '@/auth/utils'
import ECharts from 'vue-echarts'
import theme from '../../../@core/components/charts/echart/theme.json'

ECharts.registerTheme('theme-color', theme)
export default {
  name: "Home",
  components: {
    BRow,
    BCol,
  },
  mixins: [mixinVerticalLayout],
  data() {
    return {
      farmsList: [],//排行榜列表
      ranking: [],//排行榜
      width: 1400,
    }
  },
  created() {
    this.isLoggedIn = isUserLoggedIn();
    this.resizeInit()
    this.getLeaderboard()
  },
  methods: {
    resizeInit() {
      this.resizeChange()
      const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
      window.addEventListener(resizeEvt, this.resizeChange, false)
      document.documentElement.addEventListener('DOMContentLoaded', this.resizeChange, false)
    },
    resizeChange() {
      this.width = document.body.clientWidth;
    },
    getLeaderboard() {
      this.$service.get('/farmer/getRankingList')
          .then(response => {
            this.farmsList = response.data.farmerList
            this.ranking = response.data
          });
    },
    getDetail(launcherId, index) {
      this.$router.push({
        path: '/main/details', query: {
          launcherId: launcherId,
          index: index
        }
      })
    },
  }
}
</script>

<style lang="scss">
@import "~@core/scss/base/themes/bordered-layout.scss";

.table-title {
  font-weight: bold;
  padding: 10px;
  font-size: 16px;
  width: 100%;
  overflow: hidden; /*溢出隐藏*/
  text-overflow: ellipsis; /*以省略号...显示*/
  white-space: nowrap; /*强制不换行*/
}

.table-text {
  padding: 10px;
  font-size: 15px;
  width: 100%;
  overflow: hidden; /*溢出隐藏*/
  text-overflow: ellipsis; /*以省略号...显示*/
  white-space: nowrap; /*强制不换行*/
}

.table-column {
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  -webkit-flex-grow: 1;
  flex-grow: 1;
  overflow: hidden;
}

.flexible {
  -webkit-flex-grow: 1;
  flex-grow: 1;
  -webkit-flex-shrink: 1;
  flex-shrink: 1;
}

.pitch {
  flex-basis: 0;
  flex-grow: 1;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  padding: 5%;
}

.stat {
  width: 100%;
  margin-bottom: 20px;
  align-items: center;
  text-align: center;

  .labelLead {
    min-width: 120px;
    white-space: nowrap;
    font-size: 15px;
  }

  .valueLead {
    font-size: 25px;
    overflow: hidden;
    white-space: nowrap;
  }
}

.chart-container {
  height: 400px;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 90%;
  margin-left: 5%;
}


.leaderboard-page {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-align-items: center;
  align-items: center;
  max-width: 1280px;
  margin: 0 auto;
}

h4 {
  font-size: 2em;
  font-weight: 400;
  margin: .75em 0;
}
</style>
